import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aec4a6c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 摩点日报 ");
const _hoisted_2 = {
  key: 0,
  class: "dateTime"
};
const _hoisted_3 = {
  class: "time"
};
const _hoisted_4 = {
  key: 0,
  class: "empty"
};
const _hoisted_5 = {
  key: 1,
  class: "daily render-hide-scroll"
};
const _hoisted_6 = {
  key: 0,
  class: "items"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("p", null, "开售预告"), /*#__PURE__*/_createElementVNode("span", null, "超多限量档位即将开售")], -1));
const _hoisted_8 = {
  class: "list"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "title render-line-clamp"
};
const _hoisted_13 = {
  class: "categroy"
};
const _hoisted_14 = {
  class: "bottom"
};
const _hoisted_15 = {
  class: "favor_count"
};
const _hoisted_16 = {
  class: "tips"
};
const _hoisted_17 = {
  class: "time"
};
const _hoisted_18 = {
  class: "tags"
};
const _hoisted_19 = {
  key: 0,
  class: "favor"
};
const _hoisted_20 = {
  key: 1,
  class: "items"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top late"
}, [/*#__PURE__*/_createElementVNode("p", null, "众筹末班车")], -1));
const _hoisted_22 = {
  class: "list"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "info"
};
const _hoisted_26 = {
  class: "title render-line-clamp"
};
const _hoisted_27 = {
  class: "categroy"
};
const _hoisted_28 = {
  class: "bottom"
};
const _hoisted_29 = {
  class: "favor_count"
};
const _hoisted_30 = {
  class: "tips"
};
const _hoisted_31 = {
  class: "tags"
};
const _hoisted_32 = {
  key: 0,
  class: "favor"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "rank_list"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  class: "cover"
};
const _hoisted_37 = {
  key: 0,
  class: "rank first"
};
const _hoisted_38 = {
  key: 1,
  class: "rank second"
};
const _hoisted_39 = {
  key: 2,
  class: "rank third"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "title render-line-clamp"
};
const _hoisted_42 = {
  key: 2,
  class: "items"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top recommend_item"
}, [/*#__PURE__*/_createElementVNode("p", null, "项目推荐")], -1));
const _hoisted_44 = {
  class: "recommend_list"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = ["src"];
const _hoisted_47 = {
  class: "title render-line-clamp"
};
const _hoisted_48 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_Error = _resolveComponent("Error");
  const _component_van_count_down = _resolveComponent("van-count-down");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("header", {
    class: _normalizeClass([{
      'headerIOS': $data.env.isModianIos()
    }, {
      'headerAndroid': $data.env.isModianAndroid()
    }])
  }, [_createVNode(_component_icon, {
    name: "https://p6.moimg.net/path/dst_project/1569452/202305/1216/2140/2305122140kaq1RpbPOx0vObLBoxzK7QnA8w9eYV.png",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.back(), ["stop"]))
  }), _hoisted_1, $data.date ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString($data.date), 1), _createElementVNode("span", _hoisted_3, " / " + _toDisplayString($data.month) + "月", 1)])) : _createCommentVNode("", true)], 2), $data.showError ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Error, {
    img: $data.icon,
    message: $data.showMessage,
    showExtraBtn: true,
    onConfirm: $options.errorConfirm
  }, null, 8, ["img", "message", "onConfirm"])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_pull_refresh, {
    modelValue: $data.loading,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.loading = $event),
    onRefresh: $options.onRefresh
  }, {
    default: _withCtx(() => [$data.early_daily_list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.early_daily_list, (earlyItem, earlyIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "item",
        key: earlyIndex,
        onClick: _withModifiers($event => $options.goPro(earlyItem, earlyIndex, 'early'), ["stop"])
      }, [_createElementVNode("img", {
        src: `${_ctx.$imgUrlFilter(earlyItem.logo || '', 360)}`
      }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(earlyItem.category), 1), _createTextVNode(" " + _toDisplayString(earlyItem.title), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString(earlyItem.favor_count) + "人看好", 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString($options.formatDate(earlyItem.start_time)) + "开售", 1), _createElementVNode("div", _hoisted_18, [earlyItem.user_daily_tag ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(earlyItem.user_daily_tag), 1)) : _createCommentVNode("", true)])])])])], 8, _hoisted_9);
    }), 128))])])) : _createCommentVNode("", true), $data.late_daily_list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.late_daily_list, (lateItem, lateIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "item",
        key: lateIndex,
        onClick: _withModifiers($event => $options.goPro(lateItem, lateIndex, 'late'), ["stop"])
      }, [_createElementVNode("img", {
        src: `${_ctx.$imgUrlFilter(lateItem.logo || '', 360)}`
      }, null, 8, _hoisted_24), _createElementVNode("div", _hoisted_25, [_createElementVNode("p", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(lateItem.category), 1), _createTextVNode(" " + _toDisplayString(lateItem.title), 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("p", _hoisted_29, [_createElementVNode("span", null, "已筹¥" + _toDisplayString($options.formatAmount(lateItem.backer_money)) + " (" + _toDisplayString(lateItem.progress) + ")", 1), _createTextVNode(" " + _toDisplayString(lateItem.backer_count) + "人支持 ", 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("p", {
        class: _normalizeClass(['time', 'late', {
          'none': new Date(Date.parse(lateItem.end_time.replace(/-/g, '/'))) - new Date() <= 0
        }])
      }, [_createVNode(_component_van_count_down, {
        time: $options.countDown(lateItem.end_time)
      }, {
        default: _withCtx(timeData => [_createElementVNode("span", null, _toDisplayString(timeData.days) + "天", 1), _createElementVNode("span", null, _toDisplayString(timeData.hours) + "时", 1), _createElementVNode("span", null, _toDisplayString(timeData.minutes) + "分后结束", 1)]),
        _: 2
      }, 1032, ["time"])], 2), _createElementVNode("div", _hoisted_31, [lateItem.user_daily_tag ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(lateItem.user_daily_tag), 1)) : _createCommentVNode("", true)])])])])], 8, _hoisted_23);
    }), 128))])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.rank_category, (rankItem, rankIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: rankIndex,
        class: "items"
      }, [_createElementVNode("div", {
        class: "top rank_category",
        onClick: _withModifiers($event => $options.goRank(rankItem), ["stop"])
      }, [_createElementVNode("p", null, _toDisplayString(rankItem.rank_name), 1)], 8, _hoisted_33), rankItem.list && rankItem.list.length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankItem.list, (rankListItem, rankListIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: rankListIndex,
          onClick: _withModifiers($event => $options.goRankToPro(rankListItem, rankListIndex), ["stop"])
        }, [_createElementVNode("div", _hoisted_36, [rankListIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_37)) : _createCommentVNode("", true), rankListIndex == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_38)) : _createCommentVNode("", true), rankListIndex == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_39)) : _createCommentVNode("", true), _createElementVNode("img", {
          src: `${_ctx.$imgUrlFilter(rankListItem.logo || '', 408)}`
        }, null, 8, _hoisted_40)]), _createElementVNode("p", _hoisted_41, _toDisplayString(rankListItem.short_title), 1)], 8, _hoisted_35);
      }), 128))])) : _createCommentVNode("", true)]);
    }), 128)), $data.recommend_item.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recommend_item, (recommendItem, recommendIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: recommendIndex,
        onClick: _withModifiers($event => $options.goRecommondToPro(recommendItem, recommendIndex), ["stop"])
      }, [_createElementVNode("img", {
        src: `${_ctx.$imgUrlFilter(recommendItem.logo || '', 650)}`
      }, null, 8, _hoisted_46), _createElementVNode("p", _hoisted_47, _toDisplayString(recommendItem.title), 1), _createElementVNode("p", _hoisted_48, _toDisplayString(recommendItem.content), 1)], 8, _hoisted_45);
    }), 128))])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])]))], 64);
}